module.exports = __webpack_public_path__ + "media/images/sign-in-133335a3.png";